
import React from 'react';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';
import { Button } from './Button';
import { ThemedText } from './ThemedText';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sm};
  margin-bottom: ${props => props.theme.spacing.lg}; // Reduced margin
  padding-bottom: ${props => props.theme.spacing.sm}; // Reduced padding
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 28px;
`;

const BackButtonWrapper = styled.div`
  margin-left: -${props => props.theme.spacing.sm};
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center; // Align center vertically
  gap: ${props => props.theme.spacing.lg};
  flex-wrap: wrap; // Allow wrapping on very small screens
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm}; // Reduced gap
`;

const IconWrapper = styled.div`
  font-size: 20px; // Smaller icon
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; // Smaller box
  height: 32px;
  background-color: ${props => props.theme.colors.backgroundSecondary};
  border-radius: ${props => props.theme.borderRadius.md};
  border: 1px solid ${props => props.theme.colors.border};
`;

const TitleTextWrapper = styled.div`
  display: flex;
  align-items: baseline; // Align text to baseline
  gap: ${props => props.theme.spacing.sm};
`;

const ActionsWrapper = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sm};
  align-items: center;
`;

export const PageHeader = ({
    theme,
    title,
    subtitle,
    icon,
    onBack,
    backLabel = 'Back',
    actions,
    className
}) => {
    return (
        <HeaderContainer theme={theme} className={className}>
            {/* Top Row: Back Button */}
            {onBack && (
                <TopRow theme={theme}>
                    <BackButtonWrapper theme={theme}>
                        <Button
                            variant="secondary"
                            size="sm"
                            onClick={onBack}
                            style={{ padding: '4px 8px', border: 'none', height: '28px', fontSize: '12px', opacity: 0.8 }}
                        >
                            <ArrowLeft size={12} /> {backLabel}
                        </Button>
                    </BackButtonWrapper>
                </TopRow>
            )}

            {/* Title Row: Icon, Title, Subtitle, and Actions */}
            <TitleRow theme={theme}>
                <TitleContent theme={theme}>
                    {icon && (
                        <IconWrapper theme={theme}>
                            {icon}
                        </IconWrapper>
                    )}
                    <TitleTextWrapper>
                        <ThemedText type="title" style={{ lineHeight: '1', fontSize: '24px' }}>
                            {title}
                        </ThemedText>
                        {subtitle && (
                            <ThemedText style={{ color: theme.colors.muted, fontSize: '13px', fontWeight: '500' }}>
                                | {subtitle}
                            </ThemedText>
                        )}
                    </TitleTextWrapper>
                </TitleContent>

                {actions && (
                    <ActionsWrapper theme={theme}>
                        {actions}
                    </ActionsWrapper>
                )}
            </TitleRow>
        </HeaderContainer>
    );
};
